module.exports = __webpack_public_path__ + "img/join-us-3.f35254fe.png";